    const tabSync = {
        visibilityChange: null,

        setVisibilityListener(callBack) {
            if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
                this.visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this.visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this.visibilityChange = 'webkitvisibilitychange';
            }

            document.removeEventListener(this.visibilityChange, callBack, false);  // most likely not neccesary
            document.addEventListener(this.visibilityChange, callBack, false);
        },

        removeVisibilityListener(callBack) {
            document.removeEventListener(this.visibilityChange, callBack, false);
        }
    };

    export default tabSync;



// WEBPACK FOOTER //
// ./src/universal/utils/tab-sync.js